const hourFormat = 'HH:mm';

export default hourFormat;
